import template from './adpTooltip.html';
import controller from './adpTooltip.controller';
import './adpTooltip.less';

let adpTooltipComponent = {
  restrict: 'E',
  bindings: {
    opened: "=",
  },

  template,
  transclude: true,
  controller
};

export default adpTooltipComponent;



// WEBPACK FOOTER //
// ./src/app/components/adpTooltip/adpTooltip.component.js